import * as dom from './dom';

/**
 * Returns a promise that resolves after the given image URL is
 * loaded by the browser. This allows the image to be instantly loaded
 * afterwards when needed.
 *
 * The value resolved by the promise is the HTMLImageElement element
 * in the preoloading process.
 *
 * @param  {string} imageUrl
 * @return {Promise<HTMLImageElement>}
 * @see https://developer.mozilla.org/es/docs/Web/API/HTMLImageElement
 */
export function preloadImage(imageUrl) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = imageUrl;
        img.onload = () => resolve(img);
        // FIXME: Should we reject if image load fails?
        img.onerror = (e) => {
            resolve();
            console.warn(`Couldn\'t preload ${imageUrl} due to`, e);
        };
    })
}

/**
 * Returns a promise that resolves after the given stylsheet URL is
 * loaded by the browser. This allows the stylesheet to be instantly
 * loaded afterwards when needed.
 *
 * The value resolved by the promise is the HTMLLinkElement element
 * in the preoloading process.
 *
 * @param  {string} stylesheetUrl
 * @return {Promise<void>}
 * @see https://developer.mozilla.org/es/docs/Web/API/HTMLLinkElement
 */
export function preloadStyesheet(stylesheetUrl) {
    return new Promise((resolve) => {
        const link = dom.createLinkStylesheetElement({
            href: stylesheetUrl
        });
        // Append the link to the body so it is loaded
        const appendedLink = document.head.appendChild(link);
        const done = (error) => {
            if(error) {
                console.warn(`Couldn\'t preload ${stylesheetUrl} due to`, error);
            }
            // FIXME: Should we reject if stylesheet load fails (i.e.: error is defined)?
            resolve(appendedLink);
            appendedLink.remove();
        }
        appendedLink.onload = () => done();
        appendedLink.onerror = (e) => done(e);
    })
}



// WEBPACK FOOTER //
// ./src/shared/childupp-bootstrap/preload.js